import { JsonRPCService } from '@xengage/gw-portals-transport-js';
import { getProxiedServiceUrl } from '@xengage/gw-portals-url-js';

export default class AgencyActivationService {

    static activateAgency(additionalHeaders) {
        return JsonRPCService.send(
            getProxiedServiceUrl('activateAgency'),
            'activateAgency',
            [],
            additionalHeaders
        );
    }

}
